import React from 'react';
import { motion } from 'framer-motion';

const Button = ({ children, variant = 'primary', className = '', ...props }) => {
  const baseStyles = "px-6 py-3 rounded-lg font-medium transition-all duration-300 flex items-center justify-center gap-2";
  
  const variants = {
    primary: "bg-cyan-500 hover:bg-cyan-400 text-slate-950 shadow-lg shadow-cyan-500/20",
    secondary: "bg-transparent border border-slate-600 hover:border-cyan-400 text-slate-300 hover:text-cyan-400",
    ghost: "text-slate-400 hover:text-cyan-400",
    outlineSmall: "px-4 py-2 text-sm border border-cyan-500/50 text-cyan-400 hover:bg-cyan-500/10 rounded-full"
  };

  return (
    <motion.button
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      className={`${baseStyles} ${variants[variant]} ${className}`}
      {...props}
    >
      {children}
    </motion.button>
  );
};

export default Button;